
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFFFFF",
        "d": "M40.545,26.169l-3.398-6.882c-0.168-0.451-0.607-0.768-1.104-0.768\n\th-5.356v-4.772c0-0.657-0.53-1.18-1.196-1.18H10.982c-0.658,0-1.18,0.522-1.18,1.18v17.62c0,0.674,0.521,1.197,1.18,1.197h2.58\n\tc0.202,0.82,0.623,1.549,1.188,2.111c0.836,0.871,2,1.384,3.279,1.384c1.285,0,2.449-0.513,3.275-1.384\n\tc0.571-0.563,0.992-1.291,1.211-2.111h6.959c0.217,0.82,0.639,1.549,1.212,2.111c0.835,0.852,2.001,1.384,3.274,1.384\n\tc1.238,0,2.376-0.497,3.201-1.298l0.076-0.086c0.564-0.563,0.988-1.291,1.2-2.111h1.06c0.658,0,1.181-0.523,1.181-1.197v-4.658\n\tC40.679,26.537,40.629,26.35,40.545,26.169z M18.075,33.687c-1.104,0-1.999-0.897-1.999-2.001c0-1.105,0.895-1.999,1.999-1.999\n\ts2.001,0.894,2.001,1.999C20.076,32.789,19.18,33.687,18.075,33.687z M33.979,33.687c-1.104,0-2-0.897-2-2.001\n\tc0-1.104,0.896-1.999,2-1.999c1.105,0,2,0.895,2,1.999C35.979,32.789,35.084,33.687,33.979,33.687z M30.687,24.809V20.93h4.622\n\tl1.93,3.879H30.687z"
      }
    }
  ]
})
    }
  